import { IonPage } from '@ionic/react'

import { CompanyView } from '@apps-common/apps/portal/pages/management/components/company'
import { ContactView } from '@apps-common/apps/portal/pages/management/components/contact'
import { NonAllocatedSimView } from '@apps-common/apps/portal/pages/management/components/non-allocated-sim'
import { ProductView } from '@apps-common/apps/portal/pages/management/components/product'
import { ReportingView } from '@apps-common/apps/portal/pages/management/components/reporting'
import { SimApnView } from '@apps-common/apps/portal/pages/management/components/sim-apn'
import { SimTypeView } from '@apps-common/apps/portal/pages/management/components/sim-type'
import { UnitFirmwareView } from '@apps-common/apps/portal/pages/management/components/unit-firmware'
import { UnitPlanView } from '@apps-common/apps/portal/pages/management/components/unit-plan'
import { UnauthorizedCard } from '@apps-common/components/common'
import {
  MANAGEMENT_COMPANIES,
  MANAGEMENT_CONTACTS,
  MANAGEMENT_NON_ALLOCATED_SIMS,
  MANAGEMENT_PRODUCTS,
  MANAGEMENT_REPORTING,
  MANAGEMENT_SIM_APNS,
  MANAGEMENT_SIM_TYPES,
  MANAGEMENT_UNIT_FIRMWARE,
  MANAGEMENT_UNIT_PLANS
} from '@apps-common/config/management-view'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { useManagementViewStore } from '@apps-common/stores'

export const ManagementPage = () => {
  const { value } = useManagementViewStore()

  return (
    <IonPage>
      <Authorization
        roles={AUTH_CLAIMS.managementAdmin.roles}
        scopes={AUTH_CLAIMS.managementAdmin.scopes}
        notAuthorizedFallback={<UnauthorizedCard />}
      >
        <>
          {MANAGEMENT_PRODUCTS.value === value && <ProductView />}
          {MANAGEMENT_COMPANIES.value === value && <CompanyView />}
          {MANAGEMENT_CONTACTS.value === value && <ContactView />}
          {MANAGEMENT_UNIT_FIRMWARE.value === value && <UnitFirmwareView />}
          {MANAGEMENT_UNIT_PLANS.value === value && <UnitPlanView />}
          {MANAGEMENT_NON_ALLOCATED_SIMS.value === value && <NonAllocatedSimView />}
          {MANAGEMENT_SIM_APNS.value === value && <SimApnView />}
          {MANAGEMENT_SIM_TYPES.value === value && <SimTypeView />}
          {MANAGEMENT_REPORTING.value === value && <ReportingView />}
        </>
      </Authorization>
    </IonPage>
  )
}
